import 'arrayq';
import authSelectors from '../../auth/selectors';
import User from '../../auth/user';
import { selectors as metaSelectors } from '../../meta/selectors';
import { Component, Connect, React } from '../../react';
import MenuButton from '../../react-toolbox/menuButton';
import Fullscreen from '../../shared/fullscreen';
import { IBookmark, ICategory, INote, INoteChat, INoteShared, IParticipant, IQuestion, IQuestionAddressee, IQuestionDB, IQuestionPart, IUsergroup, NoteAndParticipant, isQuestion } from '../../types';
import { bookmarksBatch, bookmarksEditor, bookmarksResource } from '../bookmarks/resource';
import { categoriesBatch, categoriesEditor, categoriesResource } from '../categories/resource';
import { AdminFilter, AdminFilterJustSort, AdminFilterQuestions } from '../filter/admin';
import { InputFilter } from '../filter/inputfilter';
import Hint from '../hint';
import { notesBatch, notesEditor, notesResource } from '../notes/resource';
import { ScrollPanel } from '../scrollpanel';
import * as Tabs from '../tabs';
import { CategoryBlock } from './categoryblock';
import { Bookmarkblock, NoteblockItem } from './noteblock';
import adminReselectors from './reselectors';
import { sortFunction } from './reselectors';
import INSPECT from '../../note/notes/actions/NOTES_INSPECT';
import INSPECT_USERGROUP from '../../usergroup/actions/USERGROUP_INSPECT';
import LOGOUT from '../../auth/actions/LOGOUT';
import ADMIN_HIDE from './actions/HIDE';
import ADMIN_TAB_ACTIVATE from './actions/TAB_ACTIVATE';
import cx from './style.less';
import { notesSharedResource } from '../noteshared/resource';
import TabsSelector from '../../react-toolbox-extended/tabs';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import UPDATE_BUTTON_NO, { itemButtonTypeActionBewerkenBookmark, itemButtonTypeActionBewerkenCategory, itemButtonTypeActionBewerkenItem, itemButtonTypeActionDeleteCategory, itemButtonTypeActionDeleteItem, originAdmin } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import windowSelectors from '../../window/selectors';
import XLSX from 'xlsx';
import { isSharedNote } from '../../types';
import { sortingSelector } from '../filter/selectors';
import { usergroupBatch, usergroupEditor, usergroupResource } from '../../usergroup/resource';
import { FactionBlock, RoleBlock, RoleBlockNew, UserGroupBlock } from './usergroupblock';
import { createSelector } from 'reselect';
import { Btn } from '../../react-toolbox-redesign/button';
import { questionaddresseeEditor, questionaddresseeResource } from '../../questionaddressee/resource';
import authmng from '../../auth/selectors';
import NOTES_DELETE_BATCH_START from '../notes/actions/NOTES_DELETE_BATCH_START';
import { notechatResource } from '../notechat/resource';
import { presentationButtonSelector } from './selectors';
import { typeRoleAdmin, typeRoleClerk, typeRolePracticioner } from '../../admin/adminText';
import AdminQuestion, { AdminQuestionFactionFunctionality } from '../../admin/questionsadmin';
import { questionsResource } from '../question/resource';
import QUESTION_CHANGE_STATUS_BATCH_START from '../question/action/QUESTION_CHANGE_STATUS_BATCH_START';
import { IStatusType, canChangeQuestion, factionOfNote, getStatusString, showAnswer, showFaction, statusNieuw, statusses, statussesallowed, statussesallowedbatch } from '../question/authmodule/authcheck';
import { DeadLineLabel } from '../question/deadlineLabel/deadlineLabel';
import { beheerResource } from '../../admin/resource';
import { dateTimeFormatedString } from '../../datetime/datetime';

const isLoadingSelector = createSelector(
    notesResource.selectors.loading,
    bookmarksResource.selectors.loading,
    categoriesResource.selectors.loading,
    notesSharedResource.selectors.loading,
    usergroupResource.selectors.loading,
    (notes, bookmarks, categories, notesparticipant, users) => notes || bookmarks || categories || notesparticipant || users,
);

const typeNotes=0;
const typeQuestions=1;
const typeBookmarks=2;
const typeCategories=3;
const typeUserGroups=4;
const typeUserAdmin=5;
const typeFaction=5;

@Connect(
    (state: any) => ({
        anyBookmarks: bookmarksResource.selectors.items(state).length > 0,
        anyCategories: categoriesResource.selectors.items(state).length > 0,
        anyNotes: notesResource.selectors.items(state).length > 0,    
        anyNotesOfQuestions: notesResource.selectors.items(state).qWhere((z) => z.isquestion).length > 0,   
        anyQuestions: questionsResource.selectors.items(state).length > 0,  
        anyUsergroup: usergroupResource.selectors.items(state).length > 0, 
        allChats: notechatResource.selectors.items(state),
        allQuestions: questionsResource.selectors.items(state),
        bookmarks: adminReselectors.bookmarksItemsSelector(state),
        categories: adminReselectors.categoriesItemsSelector(state),
        categoriesAll: categoriesResource.selectors.items(state),      
        docId: metaSelectors.docId(state),
        foundBookmarks: adminReselectors.bookmarksItemsSelector(state).length > 0,
        foundCategories: adminReselectors.categoriesItemsSelector(state).length > 0,
        foundNotes: adminReselectors.notesItemsSelector(state).length > 0 || 
                    adminReselectors.notesSharedSelector(state).length > 0,
        foundQuestions: adminReselectors.questionsItemsSelector(state).length > 0,                   
        foundUsergroup: adminReselectors.usergroupSelector(state).length > 0,        
        notes: adminReselectors.notesItemsSelector(state).concat(adminReselectors.notesSharedSelector(state)),        
        listpresentation: presentationButtonSelector(state),
        questions: adminReselectors.questionsItemsSelector(state),          
        participants: adminReselectors.participantsSelector(state),
        usergroups: adminReselectors.usergroupSelector(state),     
        tabIndex: state.admin.tabIndex,
        user: authSelectors.user(state),
        visible: state.admin.visible,
        screenSmall: windowSelectors.small(state),
        height: windowSelectors.height(state),
        sorting: sortingSelector(state),
        isLoading: isLoadingSelector(state),
        anyEmailForQuestions: questionaddresseeResource.selectors.items(state).length>0,
        itemEmailForQuestions: questionaddresseeEditor.selectors.item(state),
        accountmng: authmng.accountmanager(state),
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch: any) => ({
        activateTab: (tabIndex: number) => { dispatch(ADMIN_TAB_ACTIVATE({ tabIndex }));},
        appLogout: () => dispatch(LOGOUT({})),
        close: () => dispatch(ADMIN_HIDE({})),
        createCategory: (documentId: string, name: string) => dispatch(categoriesEditor.actions.CREATE({ item: { documentId, name } })),
        deleteBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.DELETE({ item })),
        deleteBookmarks: (items: IBookmark[]) => dispatch(bookmarksBatch.actions.DELETE({ items })),
        deleteCategories: (items: ICategory[]) => dispatch(categoriesBatch.actions.DELETE({ items })),
        deleteCategory: (item: ICategory) => { 
            dispatch(UPDATE_BUTTON_NO({buttonNo: item.id, 
                origin: originAdmin, 
                buttonAction: itemButtonTypeActionDeleteCategory,
                lasttoucheditem:item}));
            dispatch(categoriesEditor.actions.DELETE({ item }));},
        createUsergroup: () => dispatch(usergroupEditor.actions.CREATE({ item: { name: '', userIDs:[] } })),  
        createRole: (type: number) => dispatch(usergroupEditor.actions.CREATE({ item: { name: '', userIDs:[], type: type } })), 
        createFaction: () => dispatch(usergroupEditor.actions.CREATE({ item: { name: '', userIDs:[], type:5 } })),
        deleteNote: (item: INote) => {  
            dispatch(UPDATE_BUTTON_NO({
                buttonNo: item.id, 
                origin: originAdmin, 
                buttonAction: itemButtonTypeActionDeleteItem,
                lasttoucheditem:item}));
            dispatch(notesEditor.actions.DELETE({ item }));},
        deleteNotes: (items: INote[]) => dispatch(NOTES_DELETE_BATCH_START({ items, batchdelete: true })),
        changeQuestionsStatus: (items: IQuestionDB[], defaultBatchStatus: IStatusType) => {
            return dispatch(QUESTION_CHANGE_STATUS_BATCH_START({ items, batchstatus: defaultBatchStatus, batchchange: true }));},
        deleteUsergroups: (items: IUsergroup[]) => dispatch(usergroupBatch.actions.DELETE_CONTINUE({ items })),
        deleteUsergroup: (item: IUsergroup) => dispatch(usergroupEditor.actions.DELETE({ item })),
        editBookmark: (item: IBookmark) => { 
            dispatch(UPDATE_BUTTON_NO({
                buttonNo: item.id, 
                origin: originAdmin, 
                buttonAction: itemButtonTypeActionBewerkenBookmark,
                lasttoucheditem:item})); 
            dispatch(bookmarksEditor.actions.UPDATE({ item }));},
        editBookmarks: (items: IBookmark[]) => dispatch(bookmarksBatch.actions.UPDATE({ items })),
        editCategory: (item: ICategory) => { 
            dispatch(UPDATE_BUTTON_NO({buttonNo: item.id, 
                origin: originAdmin, 
                buttonAction: itemButtonTypeActionBewerkenCategory,
                lasttoucheditem:item}));
            dispatch(categoriesEditor.actions.UPDATE({ item }));},
        editNote: (item: INote ) => { 
            dispatch(UPDATE_BUTTON_NO({buttonNo: item.id, 
                origin: originAdmin, 
                buttonAction: itemButtonTypeActionBewerkenItem,
                lasttoucheditem:item,
            })); 
            dispatch(notesEditor.actions.UPDATE({ item }));},    
        editNotes: (items: INote[]) => dispatch(notesBatch.actions.UPDATE({ items })),
        editUsergroup: (item: IUsergroup) => dispatch(usergroupEditor.actions.UPDATE({ item })),
        inspectNote: (item: INote | INoteShared) => dispatch(INSPECT({ item: item })),
        inspectUsergroup: (item: IUsergroup) => dispatch(INSPECT_USERGROUP({ usergroup: item })),        
        createEmailForQuestions: () => dispatch( questionaddresseeEditor.actions.CREATE({ item: { email: '' } })),
        updateEmailForQuestions: (item: IQuestionAddressee) => dispatch(questionaddresseeEditor.actions.UPDATE({item: item})),
    }), 
)

export class Admin extends Component<any, any> {
    public state = {
        selectedBookmarks: [] as number[],
        selectedCategories: [] as number[],
        selectedNotes: [] as number[],
        selectedQuestions: [] as number[],     
        expandedNotesOfQuestions: [] as number[],    
        selectedDeletableNotes: [] as number[],
        selectedEmails: [] as number[],
        selectedUsergroups: [] as number[],
    };
    
    public render() {
        const allParticipants = this.getParticipants();
        const currentUser =  allParticipants.qWhere((i)=>i.isUser).qFirst();        
        const currentUserId =  currentUser ? currentUser.id: '';  
            
        const selectBookmarksBtn = this.getSelectedBookmarks().length ?   
            <Btn 
                type="button" 
                className={'btn'} 
                extraClassNames={['ghost-btn']} 
                aria-label={'Deselecteer alle favorieten'}
                aria-haspopup={false}                        
                tabIndex={0}                                                                                                                        
                onClick={() => this.deselectAllBookmarks()}                                                                
                disabled={false}>  
                <span>DESELECTEER ALLES</span>
            </Btn>  :
            <Btn 
                type="button" 
                className={'btn'} 
                extraClassNames={['ghost-btn']} 
                aria-label={'Selecteer alle favorieten'}
                aria-haspopup={false}                        
                tabIndex={0}                                                                                                                        
                onClick={() => this.selectAllBookmarks()}                                                                
                disabled={false}>
                    <span>SELECTEER ALLES</span>
            </Btn>;          
            
        const selectCategoriesBtn = this.getSelectedCategories().length ?   
            <Btn 
                type="button" 
                className={'btn'} 
                extraClassNames={['ghost-btn']} 
                aria-label={'Deselecteer alle categorieën'}
                aria-haspopup={false}                        
                tabIndex={0}                                                                                                                        
                onClick={() => this.deselectAllCategories()}                                                                
                disabled={false}>
                <span>DESELECTEER ALLES</span>
            </Btn>  :
            <Btn 
                type="button" 
                className={'btn'} 
                extraClassNames={['ghost-btn']} 
                aria-label={'Selecteer alle categorieën'}
                aria-haspopup={false}                        
                tabIndex={0}                                                                                                                        
                onClick={() => this.selectAllCategories()}                                                                
                disabled={false}>
                    <span>SELECTEER ALLES</span>
            </Btn>;   
            
        const ActionBarVragenDownload = <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Download van vragen'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.exportFile(dataQuestions)}                                                                
                                            disabled={false}>
                                            <span>Download</span>
                                        </Btn>;

        const ActionBarVragenVerwijderen = <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Verwijder geselecteerde vragen'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.removeSelectedQuestions(selectedQuestionDeletableNotes)}
                                            disabled={false}>
                                                <span>VERWIJDER</span>
                                          </Btn>; 

        const ActionBarNoteDownload =   <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Download van vragen'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.exportFile(data)}                                                                
                                            disabled={false}>
                                                <span>Download</span>
                                        </Btn>;  

        const ActionBarNoteVerwijderen =  <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Verwijder geselecteerde notities'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.removeSelectedNotes(selectedDeletableNotes)}
                                            disabled={false}>
                                                <span>VERWIJDER</span>
                                        </Btn>;  

        const ActionChangeQuestionStatus =  <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Verander status van geselecteerde vragen'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.changeStatus(selectedQuestionsWithStatusToBeChanged, defaultBatchStatus)}
                                            disabled={false}>
                                                <span>Wijzig status</span>
                                        </Btn>;                                          

        const deleteBookmarksButton = <Btn 
                            type="button" 
                            className={'btn'} 
                            extraClassNames={['ghost-btn']} 
                            aria-label={'Verwijder geselecteerde bookmarks'}
                            aria-haspopup={false}                        
                            tabIndex={0}                                                                                                                        
                            onClick={() => this.removeSelectedBookmarks()}                                                                
                            disabled={false}>
                                <span>VERWIJDEREN</span>
                        </Btn>; 

        const createCategoryButton =    <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Nieuwe categorie'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.createCategory()}                                                                
                                            disabled={false}>
                                            <span>NIEUW</span>
                                        </Btn>;

        const deleteCategoriesButton =  <Btn 
                                            type="button" 
                                            className={'btn'} 
                                            extraClassNames={['ghost-btn']} 
                                            aria-label={'Verwijderen categorie'}
                                            aria-haspopup={false}                        
                                            tabIndex={0}                                                                                                                        
                                            onClick={() => this.removeSelectedCategories()}                                                                
                                            disabled={false}>
                                            <span>VERWIJDEREN</span>
                                        </Btn>; 

        const createUsergroupBtn =        
                            <Btn 
                                type="button" 
                                className={'btn'} 
                                extraClassNames={['ghost-btn']} 
                                aria-label={'Creëer usergroep'}
                                aria-haspopup={false}                        
                                tabIndex={0}                                                                                                                        
                                onClick={() => {this.createUsergroup();}}                                                                
                                disabled={false}>
                                    <span>NIEUW</span>
                            </Btn>;    
                            
        const createFactionBtn =        
                            <Btn 
                                type="button" 
                                className={'btn'} 
                                extraClassNames={['ghost-btn']} 
                                aria-label={'Fractie toevoegen'}
                                aria-haspopup={false}                        
                                tabIndex={0}                                                                                                                        
                                onClick={() => {this.createFaction();}}                                                                
                                disabled={false}>
                                <span>Fractie toevoegen</span>
                            </Btn>;  
        
        const smallScreenHeaderHeight=244;
        const normalScreenHeaderHeight=68;
        const panel0=0;     
        const panel1=1;                
        const panel2=2;
        const panel3=3;
        const panel4=4;
        const panel5=5;      
        const getHeight = (smallScreen: boolean, height: any) => {
            const bodyheight = (document.body.clientHeight);
            const headerHeight = smallScreen? smallScreenHeaderHeight : normalScreenHeaderHeight;
            const notBarHeight = 50;
            return bodyheight -headerHeight -notBarHeight;
        };

        const { visible, close, appLogout, screenSmall, height, sorting} = this.props;
        const { anyNotes, anyNotesOfQuestions, anyBookmarks, anyCategories, anyUsergroup, allChats, allQuestions, isLoading, listpresentation } = this.props;
        const { foundNotes, foundQuestions, foundBookmarks, foundCategories, foundUsergroup, usergroups } = this.props;
        const { itemEmailForQuestions, anyEmailForQuestions } = this.props;

        const { accountmng, beheer }  = this.props;
        var adminrec = beheer && beheer.qAny() && beheer.qFirst();
        const selectedNotes = this.getSelectedNotes();
        const selectedQuestions = this.getSelectedQuestion();
        const selectedBookmarks = this.getSelectedBookmarks(); 
        const selectedCategories = this.getSelectedCategories();    
        const downLoadButtonVisible = this.getSelectedNotes().qAny();
        const downLoadButtonVisibleQuestion = this.getSelectedQuestion().qAny();
        const deleteBookmarksButtonVisible = !selectedBookmarks.qEmpty();
        const deleteCategoryButtonVisible = !this.getSelectedCategories().length;

        const expandedNotesOfQuestions = this.getExpandedNotesOfQuestions();

        const verwijderButtonVisible = this.getNotes().qWhere((note)=> !isSharedNote(note) && (selectedNotes ? selectedNotes.qIncludes(note.id) : false)
                                        && (allChats ? !allChats.qWhere((itm: INoteChat) => note.id === itm.noteId && itm.userId!==currentUserId).qAny() : true)).qAny();
        const selectedDeletableNotes = this.getNotes().qWhere((note)=> !isSharedNote(note) && (selectedNotes ? selectedNotes.qIncludes(note.id) : false)
                                        && (allChats ? !allChats.qWhere((itm: INoteChat) => note.id === itm.noteId && itm.userId!==currentUserId).qAny() : true)).qSelect((item) =>item.id);

        const verwijderQuestionButtonVisible = this.getQuestions().qWhere((note)=>
                                        !isSharedNote(note) && (selectedQuestions ? selectedQuestions.qIncludes(note.id) : false)
                                        && (allChats ? !allChats.qWhere((itm: INoteChat) => note.id === itm.noteId && itm.userId!==currentUserId).qAny() : true)
                                        && note.status && note.status===statusNieuw,                                 
                                    ).qAny();
        const selectedQuestionDeletableNotes = this.getQuestions().qWhere((note)=> !isSharedNote(note) && (selectedQuestions ? selectedQuestions.qIncludes(note.id) : false)
                                        && (allChats ? !allChats.qWhere((itm: INoteChat) => note.id === itm.noteId && itm.userId!==currentUserId).qAny() : true)
                                        && note.status && note.status===statusNieuw,
                                    ).qSelect((item) =>item.id);
        const changeStatusVisible = 
            allQuestions.qWhere((question: IQuestionDB)=> (
                selectedQuestions ? 
                selectedQuestions.qIncludes(question.noteId) : false) &&
                statussesallowed(statusses, question.status, currentUserId, usergroups ).qAny((x) =>x.id !== question.status) &&
                canChangeQuestion(statusses, question.status, currentUserId, usergroups, adminrec))
            .qAny();
        const defaultBatchStatus = statussesallowedbatch(statusses, allQuestions, currentUserId, usergroups).qFirst();
        const selectedQuestionsWithStatusToBeChanged = allQuestions.qWhere((question: IQuestionDB)=> (selectedQuestions ? selectedQuestions.qIncludes(question.noteId) : false)).qSelect((item: IQuestionDB) =>item.id);

        // afzender, datum en tijd, pagina(kruimelpad), url waar de vraag overgaat, verwijzing, onderwerp, vraag
        var domain = window.location.origin || `${window.location.protocol}//${window.location.host}`; 
        const titles = [['Afzender', 'Datum en tijd', 'Url', 'Notitie', 'Pagina(kruimelpad)']];
        const data = titles.concat(this.getNotes()
            .qWhere((eml)=> (selectedNotes ? selectedNotes.qIncludes(eml.id) : false))
            .map((note) => ([
                    this.mailFromName(note.userId, allParticipants), 
                    dateTimeFormatedString(note.created),                 
                    note.breadcrumb ? (note.breadcrumb==='Home'? domain: domain + note.url) : '',
                    note.text, 
                    ].concat(this.breadcrumbItems(note))))); 

        const titlesQuestion = [['Datum & Tijd', 'Afzender', 'Fractie', 'Status', 'Technische vraag ', 'Antwoord technische vraag', 'pagina(kruimelpad)']];
        const dataQuestions = titlesQuestion.concat(this.getQuestions()
            .qWhere((eml)=> (selectedQuestions ? selectedQuestions.qIncludes(eml.id) : false))
            .map((note) => { 
                    return ([
                                dateTimeFormatedString(note.created),
                                this.mailFromName(note.userId, allParticipants), 
                                (showFaction(note.status, note.userId, currentUserId, usergroups) ? factionOfNote(note, usergroups): ''),
                                note.status ? getStatusString(note.status): getStatusString(statusNieuw),
                                note.text, 
                                showAnswer(note.status, currentUserId, usergroups) ? note.antwoordConcern:'',
                            ].concat(this.breadcrumbItems(note)));}));                     

        var items = this.getNotes();    
        var itemsQuestions = this.getQuestions();                
        var foundItems = foundNotes;
        var foundQuestionItems = foundQuestions;
        var anyItems = anyNotes;
        var anyQuestionItems = anyNotesOfQuestions;
    
        var adminAccess = accountmng || this.getRole(typeRoleAdmin).qAny((itm)=> itm.userIDs.includes(currentUserId));
        
        return (
            <Fullscreen visible={visible}>
                <div className={cx('admin', !visible? 'wcag-invisible' : '')} 
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden={!visible} 
                    aria-label="Mijn items">
                    <FocusLockFocusGuard 
                        disabled={!visible}>                                   
                        <div className={cx('outer-container')}> 
                            <div className={cx('menu-container')}>
                                    <div className={cx('header')}>
                                        <div className={cx('tabs')}>
                                            {adminAccess ?                                                                                        
                                                <TabsSelector 
                                                    activeIndex={this.props.tabIndex} 
                                                    onChange={ this.props.activateTab }
                                                    smallScreen={screenSmall}
                                                    containerClass={'main-menu'}
                                                    >                                                
                                                    <button 
                                                        role="tab"
                                                        title="Notities"
                                                        aria-selected={this.props.activateTab===panel0}>    
                                                        Notities                                             
                                                    </button>   
                                                    <button 
                                                        role="tab"
                                                        title="Technische vragen"
                                                        aria-selected={this.props.activateTab===panel1}>    
                                                        Notities                                             
                                                    </button>                                                                                              
                                                    <button
                                                        role="tab"
                                                        title="Favorieten"
                                                        aria-selected={this.props.activateTab===panel2}>
                                                    </button>
                                                    <button 
                                                        role="tab"
                                                        title="Categorieën"
                                                        aria-selected={this.props.activateTab===panel3}>
                                                    </button>
                                                    <button 
                                                        role="tab"
                                                        title="Groepen"
                                                        aria-selected={this.props.activateTab===panel4}>
                                                    </button>     
                                                    <button 
                                                        role="tab"
                                                        title="Beheer"
                                                        aria-selected={this.props.activateTab===panel5}>
                                                    </button>                                                                                  
                                                </TabsSelector>:
                                                <TabsSelector 
                                                    activeIndex={this.props.tabIndex} 
                                                    onChange={ this.props.activateTab }
                                                    smallScreen={screenSmall}
                                                    containerClass={'main-menu'}
                                                    >                                                
                                                    <button 
                                                        role="tab"
                                                        title="Notities"
                                                        aria-selected={this.props.activateTab===panel0}>    
                                                        Notities                                             
                                                    </button>   
                                                    <button 
                                                        role="tab"
                                                        title="Technische vragen"
                                                        aria-selected={this.props.activateTab===panel1}>    
                                                        Notities                                             
                                                    </button>                                                                                              
                                                    <button
                                                        role="tab"
                                                        title="Favorieten"
                                                        aria-selected={this.props.activateTab===panel2}>
                                                    </button>
                                                    <button 
                                                        role="tab"
                                                        title="Categorieën"
                                                        aria-selected={this.props.activateTab===panel3}>
                                                    </button>
                                                    <button 
                                                        role="tab"
                                                        title="Groepen"
                                                        aria-selected={this.props.activateTab===panel4}>
                                                    </button>                                                                                     
                                                </TabsSelector>
                                            }
                                        </div>
                                        <div className={cx('header-buttons')}>
                                            <div className={cx('user-btn-container')}> 
                                                <MenuButton className={cx('user-btn')} 
                                                            position="topRight" 
                                                            arialabel="Uitloggen en wachtwoord wijzigen buttonmenu"
                                                            text={User.abbrUserName(this.props.user.name)}
                                                            >
                                                    { !!accountmng ?
                                                        <button 
                                                            className={cx('btn', 'icon_email')} 
                                                            aria-label={`Standaard emailadres voor vragen`}                  
                                                            tabIndex={0} 
                                                            onClick={() => this.changeOrUpdateEmailForQuestions(anyEmailForQuestions ? itemEmailForQuestions as IQuestionAddressee: null)}>
                                                            Emailadres voor vragen
                                                        </button> : null }                                                                                                                                                                                           
                                                    <button 
                                                        className={cx('btn', 'icon_change-password')} 
                                                        aria-label={`Wachtwoord wijzigen`}                  
                                                        tabIndex={0} 
                                                        onClick={this.appChangePassword}>
                                                        Wachtwoord wijzigen
                                                    </button>
                                                    <button 
                                                        className={cx('btn', 'icon_logout')} 
                                                        aria-label={`Uitloggen`}                  
                                                        tabIndex={0} 
                                                        onClick={appLogout}>
                                                        Uitloggen
                                                    </button>                                                      
                                                </MenuButton>
                                            </div>
                                            <button 
                                                className={cx('btn', 'icon-btn', 'close')} 
                                                aria-label={`Sluiten van mijn items`}                  
                                                tabIndex={0} 
                                                onClick={close}>
                                                <span aria-hidden="true" className={cx('icon-close')}></span>
                                            </button>
                                        </div>
                                    </div>                                        
                            </div>
                                                        
                            <div className={cx('action-bar') + ' actionbar'}>
                                <div className={cx('action-bar-inner')}>
                                    <div className={cx('buttons-container')}>                                                                               
                                            <div className={cx(!(this.props.tabIndex===panel0 && downLoadButtonVisible)? 'wcag-invisible' : '')} >
                                                    {ActionBarNoteDownload}
                                            </div> 
                                            <div className={cx(!(this.props.tabIndex===panel0 && verwijderButtonVisible)? 'wcag-invisible' : '')} >
                                                {ActionBarNoteVerwijderen}
                                            </div>
                                            <div className={cx(!(this.props.tabIndex===panel1 && downLoadButtonVisibleQuestion)? 'wcag-invisible' : '')} >
                                                    {ActionBarVragenDownload}
                                            </div> 
                                            <div className={cx(!(this.props.tabIndex===panel1 && changeStatusVisible)? 'wcag-invisible' : '')} >
                                                {ActionChangeQuestionStatus}
                                            </div>
                                            <div className={cx(!(this.props.tabIndex===panel1 && verwijderQuestionButtonVisible)? 'wcag-invisible' : '')} >
                                                {ActionBarVragenVerwijderen}
                                            </div>                                                     
                                            <div className={cx(!(this.props.tabIndex===panel2)? 'wcag-invisible' : '')} >
                                                    {selectBookmarksBtn}
                                            </div> 
                                            <div className={cx(!(this.props.tabIndex===panel2 && deleteBookmarksButtonVisible)? 'wcag-invisible' : '')} >
                                                {deleteBookmarksButton}
                                            </div> 
                                            <div className={cx(!(this.props.tabIndex===panel3)? 'wcag-invisible' : '')} >
                                                    {createCategoryButton}
                                            </div> 
                                            <div className={cx(!(this.props.tabIndex===panel3)? 'wcag-invisible' : '')} >
                                                    {selectCategoriesBtn}
                                            </div>                                             
                                            <div className={cx(!(this.props.tabIndex===panel3 && deleteCategoryButtonVisible)? 'wcag-invisible' : '')} >
                                                {deleteCategoriesButton}
                                            </div>                                             
                                            <div className={cx(!(this.props.tabIndex===panel4)? 'wcag-invisible' : '')} >
                                                    {createUsergroupBtn}
                                            </div>   
                                                            
                                    </div>
                                    <InputFilter type={this.props.tabIndex===panel0 ? typeNotes:
                                                       this.props.tabIndex=== panel1 ? typeQuestions:
                                                        this.props.tabIndex===panel2 ? typeBookmarks:
                                                        this.props.tabIndex===panel3 ? typeCategories: 
                                                        this.props.tabIndex===panel4 ? typeUserGroups:
                                                        typeUserAdmin
                                                        } />
                                </div>
                            </div> 
                             
                            <ScrollPanel style={{ height: getHeight(screenSmall, height).toString() + 'px', width: '100%'}}>
                                    {(({ top }: any) => 
                                    (  
                                    <Tabs.Switch activeIndex={this.props.tabIndex}>
                                        <Tabs.Panel label="Notities">
                                            <div className={cx('tab-content')}>                                            
                                                <div className={cx('tab-content-container')}>

                                                    <div className={cx('filter-container-admin')}>
                                                        <AdminFilter />                          
                                                    </div>                     
                                                                                                    
                                                    <div className={cx('items', screenSmall ? 'items-container-small': 'items-container-big')}>

                                                        { isLoading? <Hint big text="Notities worden geladen" /> :
                                                          foundItems ? null : anyItems ? <Hint big text="Geen notities gevonden" /> : <Hint big text="Geen notities" />}

                                                        <div className={cx('items-inner-container', (listpresentation ? 'list-active': 'tile-active'))}>
                                                            { listpresentation && !isLoading ? 
                                                                <div className={cx('list-header')}>
                                                                    <div className={cx('list-title-container')}></div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div className={cx('default-checkbox-div', 'check-box-selection')} tabIndex={-1}>
                                                                            <input type="checkbox" 
                                                                                className={cx('default-checkbox')} 
                                                                                tabIndex={-1}  
                                                                                onChange={() => {
                                                                                    (this.props.tabIndex===panel0&&this.getSelectedNotes()&&this.getSelectedNotes().length>0)?
                                                                                    this.deselectAll():
                                                                                    this.selectAll();
                                                                                }}
                                                                                checked={(this.props.tabIndex===panel0&&this.getSelectedNotes()&&this.getSelectedNotes().length>0)}
                                                                                aria-hidden={true}/>
                                                                            <div role="checkbox" 
                                                                                className={cx('checkmark')}
                                                                                onClick={() => {
                                                                                    (this.props.tabIndex===panel0&&this.getSelectedNotes()&&this.getSelectedNotes().length>0)?
                                                                                    this.deselectAll():
                                                                                    this.selectAll();
                                                                                }}
                                                                                tabIndex={0}
                                                                                >
                                                                            </div> 
                                                                        </div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div></div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div>Aangemaakt door</div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        {/* <div>Fractie</div> */}
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div>Aangemaakt op</div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        {/* <div>Status</div> */}
                                                                    </div> 
                                                                    <div className={cx('list-title-container')}>
                                                                        <div></div>
                                                                    </div>
                                                                    
                                                                </div> : ''
                                                            }
                                                            {items
                                                                .sort(sortFunction(sorting))
                                                                .qSelect((note) => {
                                                                    var disableDelete = note && (allChats ? allChats.qWhere((itm: INoteChat) => note.id === itm.noteId && itm.userId!==currentUserId).qAny() : false);
                                                                    var key = isSharedNote(note) ? notesSharedResource.fields.key(note as INoteShared): notesResource.fields.key(note as INote);
                                                                    var itemno = parseInt(key);
                                                                    return <NoteblockItem
                                                                        key={key}
                                                                        itemKey={key.toString()}
                                                                        categories={this.props.categoriesAll}
                                                                        item={note}
                                                                        itemno={itemno}
                                                                        selected={selectedNotes.qIncludes(note.id)}
                                                                        onSelect={this.toggleNote}
                                                                        onEdit={this.props.editNote}
                                                                        onDelete={this.props.deleteNote} 
                                                                        onInspect={this.props.inspectNote}  
                                                                        disableDelete = {disableDelete}                                                    
                                                                    />;
                                                                })
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                            </div> 
                                        </Tabs.Panel>
                                        <Tabs.Panel label="Vragen">
                                            <div className={cx('tab-content')}>                                                                                       
                                                <div className={cx('tab-content-container')}>

                                                    <div className={cx('filter-container-admin')}>
                                                        <DeadLineLabel />
                                                        <AdminFilterQuestions />                          
                                                    </div>                     
                                                                                                    
                                                    <div className={cx('items', screenSmall ? 'items-container-small': 'items-container-big')}>

                                                        { isLoading? <Hint big text="Vragen worden geladen" /> :
                                                          foundQuestionItems ? null : anyQuestionItems ? <Hint big text="Geen vragen gevonden" /> : <Hint big text="Geen vragen" />}

                                                        <div className={cx('items-inner-container', 'list-active')}>
                                                        { !isLoading ? 
                                                                <div className={cx('list-header')}>
                                                                    <div className={cx('list-title-container')}></div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div className={cx('default-checkbox-div', 'check-box-selection')} tabIndex={-1}>
                                                                            <input type="checkbox" 
                                                                                className={cx('default-checkbox')} 
                                                                                tabIndex={-1}  
                                                                                onChange={() => {
                                                                                    (this.props.tabIndex===panel1 && this.getSelectedQuestion() && this.getSelectedQuestion().length>0)?
                                                                                    this.deselectAllQuestions():
                                                                                    this.selectAllQuestions();
                                                                                }}
                                                                                checked={(this.props.tabIndex===panel1 && this.getSelectedQuestion() && this.getSelectedQuestion().length>0)}
                                                                                aria-hidden={true}/>
                                                                            <div role="checkbox" 
                                                                                className={cx('checkmark')}
                                                                                onClick={() => {
                                                                                    (this.props.tabIndex===panel1 && this.getSelectedQuestion() && this.getSelectedQuestion().length>0)?
                                                                                    this.deselectAllQuestions():
                                                                                    this.selectAllQuestions();
                                                                                }}
                                                                                tabIndex={0}
                                                                                >
                                                                            </div> 
                                                                        </div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div></div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div>Aangemaakt door</div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div>Fractie</div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div>Aangemaakt op</div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div>Status</div>
                                                                    </div>
                                                                    <div className={cx('list-title-container')}>
                                                                        <div></div>
                                                                    </div>

                                                                </div> : ''
                                                            }
                                                            {itemsQuestions
                                                                .qWhere((ques)=> {   
                                                                    // 1) only items with no parents OR
                                                                    // 2) items of which the parent is expanded.
                                                                    return !ques.parentId ||
                                                                            expandedNotesOfQuestions.qIncludes(ques.parentId);
                                                                })
                                                                .qSelect((question) => {
                                                                    var disableDelete = (allChats ? allChats.qWhere((itm: INoteChat) => question.id === itm.noteId && itm.userId!==currentUserId).qAny() : false) || 
                                                                                        (question.userId!==currentUserId) ||
                                                                                        (question && question.status && question.status>statusNieuw);                                                     
                                                                    var key = isSharedNote(question) ? notesSharedResource.fields.key(question as INoteShared): notesResource.fields.key(question as INote);
                                                                    var itemno = parseInt(key);
                                                                    return <NoteblockItem
                                                                        key={key}
                                                                        itemKey={key.toString()}
                                                                        categories={this.props.categoriesAll}
                                                                        item={question}
                                                                        itemno={itemno}
                                                                        participants={allParticipants}
                                                                        selected={selectedQuestions.qIncludes(question.id)}
                                                                        expanded={expandedNotesOfQuestions.qIncludes(question.id)}
                                                                        onSelect={this.toggleQuestion}
                                                                        onExpand={this.toggleNotesOfQuestionsExpand}
                                                                        onEdit={this.props.editNote}
                                                                        onDelete={this.props.deleteNote} 
                                                                        onInspect={this.props.inspectNote}  
                                                                        disableDelete = {disableDelete}                                                    
                                                                    />;
                                                                })
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                            </div> 
                                        </Tabs.Panel>                                        
                                        <Tabs.Panel label="Favorieten">
                                            <div className={cx('tab-content')}>
                                                <div className={cx('tab-content-container')}>
                                                    <div className={cx('filter-container-admin')}>
                                                        <AdminFilterJustSort />                        
                                                    </div> 

                                                    <div className={cx('items', screenSmall ? 'items-container-small': 'items-container-big')}>
                                                        
                                                        { isLoading? <Hint big text="Favorieten worden geladen" /> :
                                                        foundBookmarks ? null : anyBookmarks ? <Hint big text="Geen favorieten gevonden" /> : <Hint big text="Geen favorieten" />}
                                                        
                                                        <div className={cx('bookmarks-inner-container')}>
                                                            {this.getBookmarks().qSelect((bookmark) => {
                                                                return <Bookmarkblock
                                                                    key={'bo' + bookmarksResource.fields.key(bookmark)}
                                                                    categories={this.props.categoriesAll}
                                                                    item={bookmark}
                                                                    itemno={parseInt(bookmarksResource.fields.key(bookmark))}
                                                                    selected={selectedBookmarks.qIncludes(bookmark.id)}
                                                                    onSelect={this.toggleBookmark}
                                                                    onEdit={this.props.editBookmark}
                                                                    onDelete={this.props.deleteBookmark}
                                                                    extraClassNames={'bookmark-item'}
                                                                />;
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tabs.Panel>
                                        <Tabs.Panel label="Categorieën">
                                            <div className={cx('tab-content')}>
                                                <div className={cx('tab-content-container')}>
                                                    <div className={cx('items', 'category-items', screenSmall ? 'items-container-small': 'items-container-big')}>

                                                        { isLoading? <Hint big text="Categorieën worden geladen" /> :
                                                        foundCategories ? null : anyCategories ? <Hint big text="Geen categorieën gevonden" /> : <Hint big text="Geen categorieën" />}
                                                        
                                                        <div className={cx('categories-inner-container')}>
                                                            {this.getCategories().qSelect((category) => {
                                                                return <CategoryBlock
                                                                    key={'ca' + categoriesResource.fields.key(category)}
                                                                    item={category}
                                                                    itemno={category.id}
                                                                    selected={selectedCategories.qIncludes(category.id)}
                                                                    onSelect={this.toggleCategory}
                                                                    onEdit={this.props.editCategory}
                                                                    onDelete={this.props.deleteCategory}
                                                                    extraClassNames={'category-item'}
                                                                />;
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tabs.Panel>
                                        <Tabs.Panel label="Groepen">
                                            <div className={cx('tab-content')}>
                                                <div className={cx('tab-content-container')}>
                                                    <div className={cx('items', 'usergroup-items', screenSmall ? 'items-container-small': 'items-container-big')}>

                                                        { isLoading? <Hint big text="Groepen worden geladen" /> :
                                                        foundUsergroup ? null : anyUsergroup ? <Hint big text="Geen groepen gevonden" /> : <Hint big text="Geen groepen" />}
                                                        
                                                        <div className={cx('usergroup-title')}>Mijn groepen</div>
                                                        <div className={cx('usergroup-inner-container', 'top')}>
                                                            {this.getMyUsergroups(currentUserId).qSelect((usergroup) => {
                                                                return <UserGroupBlock
                                                                    keyprefix={'mg'}
                                                                    key={'mg' + usergroupResource.fields.key(usergroup)}
                                                                    item={usergroup}
                                                                    itemno={usergroup.id}
                                                                    onEdit={this.props.editUsergroup}
                                                                    onInspect={this.props.inspectUsergroup}
                                                                    onDelete={this.props.deleteUsergroup}
                                                                    extraClassNames={cx('usergroup-item')}
                                                                />;
                                                            })}
                                                        </div> 
                                                        <div className={cx('usergroup-title')}>Lid van groepen</div>
                                                        <div className={cx('usergroup-inner-container', 'bottom')}>                                                            
                                                            {this.getUsergroupsWithMeInIt(currentUserId).qSelect((usergroup) => {
                                                                return <UserGroupBlock
                                                                    keyprefix={'lvg'}
                                                                    key={'lvg' + usergroupResource.fields.key(usergroup)}
                                                                    item={usergroup}
                                                                    itemno={usergroup.id}
                                                                    onEdit={this.props.editUsergroup}
                                                                    onInspect={this.props.inspectUsergroup}
                                                                    onDelete={this.props.deleteUsergroup}
                                                                    extraClassNames={'usergroup-item'}
                                                                />;
                                                            })}
                                                        </div>                                                 
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </Tabs.Panel>       
                                        <Tabs.Panel label="Beheer">
                                            <div className={cx('tab-content')}>
                                                <div className={cx('tab-content-container')}>
                                                    <div className={cx('admin-area')}>
                                                        <div className={cx('admin-area-inner')}>
                                                            <div className={cx('admin-title')}>Technische vragen</div>
                                                            <div className={cx('admin-inner-container', 'top')}>
                                                                <AdminQuestion key={'admin_key_1'}/>
                                                            </div> 
                                                            <div className={cx('admin-title')}>Rollen en rechten</div>
                                                            <div className={cx('admin-inner-container', 'middle')}>
                                                                { this.getRole(typeRoleAdmin).qAny() ? 
                                                                    this.getRole(typeRoleAdmin).qSelect((roleadm) => {                                                                                
                                                                    return  <RoleBlock keyprefix={'roladm'}
                                                                            key={'roladm' + usergroupResource.fields.key(roleadm)}
                                                                            item={roleadm}
                                                                            itemno={roleadm.id}
                                                                            onEdit={this.props.editUsergroup}
                                                                            onInspect={this.props.inspectUsergroup}   
                                                                            onDelete={() => {}}                                                                 
                                                                            extraClassNames={cx('item-adminrole')}
                                                                            />;
                                                                }): <RoleBlockNew keyprefix={'roladm'}
                                                                        key={'roladm' + typeRoleAdmin.toString()}                                                                    
                                                                        itemno={typeRoleAdmin}                                                                                                        
                                                                        extraClassNames={cx('item-adminrole')}
                                                                        typeRole={typeRoleAdmin} />   
                                                                }  
                                                                { this.getRole(typeRoleClerk).qAny() ? 
                                                                this.getRole(typeRoleClerk).qSelect((roleclrk) => {                   
                                                                    return  <RoleBlock keyprefix={'roleclrk'}
                                                                            key={'rolclrk' + usergroupResource.fields.key(roleclrk)}
                                                                            item={roleclrk}
                                                                            itemno={roleclrk.id}
                                                                            onEdit={this.props.editUsergroup}
                                                                            onInspect={this.props.inspectUsergroup}   
                                                                            onDelete={() => {}}                                                                 
                                                                            extraClassNames={cx('item-clrkrole')}
                                                                            />;
                                                                }): <RoleBlockNew keyprefix={'roleclrk'}
                                                                    key={'roleclrk' + typeRoleClerk.toString()}                                                                    
                                                                    itemno={typeRoleClerk}                                                                                                        
                                                                    extraClassNames={cx('item-clrkrole')}
                                                                    typeRole={typeRoleClerk} />                                                            
                                                                }
                                                                {this.getRole(typeRolePracticioner).qAny() ? 
                                                                    this.getRole(typeRolePracticioner).qSelect((rolepract) => {                   
                                                                        return  <RoleBlock keyprefix={'rolepract'}
                                                                                key={'rolclrk' + usergroupResource.fields.key(rolepract)}
                                                                                item={rolepract}
                                                                                itemno={rolepract.id}
                                                                                onEdit={this.props.editUsergroup}
                                                                                onInspect={this.props.inspectUsergroup}   
                                                                                onDelete={() => {}}                                                                 
                                                                                extraClassNames={cx('item-rolepract')}
                                                                                />;
                                                                        }): <RoleBlockNew keyprefix={'rolepract'}
                                                                            key={'rolepract' + typeRolePracticioner.toString()}                                                                    
                                                                            itemno={typeRolePracticioner}                                                                                                        
                                                                            extraClassNames={cx('item-rolepract')}
                                                                            typeRole={typeRolePracticioner} />                                                                                                                         
                                                                }                                                              
                                                                                                    
                                                            </div>                                                            
                                                            <div className={cx('admin-title')}>Fracties</div>
                                                            <div className={cx('admin-inner-container', 'middle-2nd')}>
                                                                <AdminQuestionFactionFunctionality key={'admin_faction_key_1'}/>
                                                            </div>          
                                                            <div className={cx('admin-inner-container', 'bottom-button')}>
                                                                <div>
                                                                    {createFactionBtn}
                                                                </div>
                                                            </div>
                                                            <div className={cx('admin-inner-container', 'bottom')}>                                                            
                                                                {this.getFactions().qSelect((usergroup) => {
                                                                    return <FactionBlock
                                                                        keyprefix={'fa'}
                                                                        key={'fa' + usergroupResource.fields.key(usergroup)}
                                                                        item={usergroup}
                                                                        itemno={usergroup.id}
                                                                        onEdit={this.props.editUsergroup}
                                                                        onInspect={this.props.inspectUsergroup}
                                                                        onDelete={this.props.deleteUsergroup}
                                                                        extraClassNames={cx('usergroup-item')}
                                                                    />;
                                                                })}
                                                            </div>     
                                                        </div>                                                                                               
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </Tabs.Panel>
                                    </Tabs.Switch>
                                    ))}
                                </ScrollPanel>
                            </div>                        
                       
                     </FocusLockFocusGuard> 
                </div>
            </Fullscreen>
        );
    }

    breadcrumbItems(note: INote) {
        if (note && note.breadcrumb) {
            const breadcrumb = note.breadcrumb;
            return breadcrumb.replace('Home>', '').replace('Home', '').split('>');
        }
    }

    mailFromName(mailFromId: string, allParticipants: IParticipant[]) {    
        if(allParticipants&&mailFromId) {
            if (allParticipants.qWhere((participant)=> participant.id === mailFromId).qAny()) {
                return allParticipants.qWhere((participant)=> participant.id === mailFromId).qFirst().name;
            }
        }
        return '';        
    }

    exportFile(data: any[][]) {
        /* convert state to workbook */
        const ws = XLSX.utils.aoa_to_sheet(data);        
        for (var z in ws) {
            /* all keys that do not begin with "!" correspond to cell addresses */
            if(ws[z].v != null && typeof ws[z].v === 'string' && ws[z].v.indexOf('https') === 0 ) {
                ws[z] = {f: '=HYPERLINK("' + ws[z].v.toString() + '","'+ ws[z].v.toString() +'")',
                    s: {
                        fill: {
                            patternType: 'solid', // none / solid
                            fgColor: {rgb: 'FFD3D3D3'},
                        },   
                    },  
                }; 
            }
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, 'GedeeldeTechnischeVragen.xlsx');
    }

    convertToPlain(html: string) {

        // Create a new div element
        var tempDivElement = document.createElement('div');
    
        // Set the HTML content with the given value
        tempDivElement.innerHTML = html;
    
        // Retrieve the text property of the element 
        return tempDivElement.textContent || tempDivElement.innerText || '';
    }
    
    private getSelectedQuestion() {
        return this.state.selectedQuestions.qIntersect(this.getQuestions().qSelect((x) => x.id));
    } 
    private getSelectedNotes() {
        return this.state.selectedNotes.qIntersect(this.getNotes().qSelect((x) => x.id));
    }
    private getSelectedBookmarks() {
        return this.state.selectedBookmarks.qIntersect(this.getBookmarks().qSelect((x) => x.id));
    }
    private getSelectedCategories() {
        return this.state.selectedCategories.qIntersect(this.getCategories().qSelect((x) => x.id));
    }

    private getExpandedNotesOfQuestions() {
        return this.state.expandedNotesOfQuestions.qIntersect(this.getQuestions().qSelect((x) => x.id));
    }

    private toggleNote = (item: INote | INoteShared) => {
        if (this.getSelectedNotes().qIncludes(item.id)) {
            this.setState({ selectedNotes: this.getSelectedNotes().qWhere((x) => x !== item.id) });
        } else {
            this.setState({ selectedNotes: [...this.getSelectedNotes(), item.id].sort() });
        }
    }

    private toggleAllNotes(select: boolean) {
        if (select) {
            this.setState({ selectedNotes: [...this.getSelectedNotes(), ...this.getNotes().qWhere((z) => !z.isquestion).qSelect((note) => note.id)].sort() });
        } else {
            this.setState({ selectedNotes: [] });
        }
    }

    private toggleQuestion = (item: INote | INoteShared) => {
        const selected = this.props.allQuestions.qWhere((o: IQuestionDB) => o.noteId === item.id || o.parentId=== item.id) as IQuestionDB[];
        const selectedIds = selected.qSelect((que)=> que.noteId);
        if (this.getSelectedQuestion().qIncludes(item.id)) {
            this.setState({ selectedQuestions: this.getSelectedQuestion().qWhere((x) => !selectedIds.qAny((Ids) => Ids===x)) });
        } else {
            this.setState({ selectedQuestions: [...this.getSelectedQuestion(), ...selectedIds].sort() });
        }
    }

    private toggleAllQuestions(select: boolean) {
        if (select) {
            this.setState({ selectedQuestions: [...this.getSelectedQuestion(), ...this.getQuestions().qSelect((note) => note.id)].sort() });
        } else {
            this.setState({ selectedQuestions: [] });
        }
    }

    private toggleNotesOfQuestionsExpand = (item: INote) => {
        if (this.getExpandedNotesOfQuestions().qIncludes(item.id)) {
            this.setState({ expandedNotesOfQuestions: this.getExpandedNotesOfQuestions().qWhere((x) => x !== item.id) });
        } else {          
            this.setState({ expandedNotesOfQuestions: [...this.getExpandedNotesOfQuestions(), item.id].sort() });
        }
    }       

    private toggleBookmark = (item: IBookmark) => {
        if (this.getSelectedBookmarks().qIncludes(item.id)) {
            this.setState({ selectedBookmarks: this.getSelectedBookmarks().qWhere((x) => x !== item.id) });
        } else {
            this.setState({ selectedBookmarks: [...this.getSelectedBookmarks(), item.id].sort() });
        }
    }

    private toggleAllBookmarks(select: boolean) {
        if (select) {
            this.setState({ selectedBookmarks: [...this.getSelectedBookmarks(), ...this.getBookmarks().qSelect((bookmark) => bookmark.id)].sort() });
        } else {
            this.setState({ selectedBookmarks: [] });
        }
    }

    private toggleCategory = (item: ICategory) => {
        if (this.getSelectedCategories().qIncludes(item.id)) {
            this.setState({ selectedCategories: this.getSelectedCategories().qWhere((x) => x !== item.id) });
        } else {
            this.setState({ selectedCategories: [...this.getSelectedCategories(), item.id].sort() });
        }
    }

    private changeOrUpdateEmailForQuestions = (item: IQuestionAddressee) => {
        if (!item) {
            this.props.createEmailForQuestions();
        } else {
            this.props.updateEmailForQuestions(item);
        }
    } 
 
    private toggleAllCategories(select: boolean) {
        if (select) {
            this.setState({ selectedCategories: [...this.getSelectedCategories(), ...this.getCategories().qSelect((category) => category.id)].sort() });
        } else {
            this.setState({ selectedCategories: [] });
        }
    } 

    private removeSelectedNotes = (selectedDeletableIDs: number[]) => {
        // const selectedIDs = this.getSelectedNotes();
        this.props.deleteNotes(this.getNotes().qWhere((note) => !isSharedNote(note) && selectedDeletableIDs.qIncludes(note.id)));
    } 

    private changeStatus = (selectedChangableIDs: number[], defaultBatchStatus: IStatusType) => {
        this.props.changeQuestionsStatus(this.props.allQuestions.qWhere((question: IQuestionDB) => selectedChangableIDs.qIncludes(question.id)), defaultBatchStatus);
    }

    private removeSelectedQuestions = (selectedDeletableIDs: number[]) => {
        // const selectedIDs = this.getSelectedNotes();
        this.props.deleteNotes(this.getQuestions().qWhere((question) => !isSharedNote(question) && selectedDeletableIDs.qIncludes(question.id)));
    }    

    private removeSelectedBookmarks = () => {
        const selectedIDs = this.getSelectedBookmarks();
        this.props.deleteBookmarks(this.getBookmarks().qWhere((note) => selectedIDs.qIncludes(note.id)));
    }
    private createCategory = () => {
        this.props.createCategory(this.props.docId, 'Categorie');
    }
    private createUsergroup= () => {
        this.props.createUsergroup();
    }
    private createFaction= () => {
        this.props.createFaction();
    }
 
    private removeSelectedCategories = () => {
        const selectedIDs = this.getSelectedCategories();
        this.props.deleteCategories(this.getCategories().qWhere((note) => selectedIDs.qIncludes(note.id)));
    }

    private appChangePassword = () => {
        const changepasswordurl = process.env.CHANGEPASSWORDURL;
        if (changepasswordurl!==undefined)
            window.open(changepasswordurl);
        else {
            if (process.env.NODE_STAGE === 'test')
                window.open('https://lias-online-accountmanagement-dev.azurewebsites.net/Account/ChangePassword');
            else    
                window.open('https://account.liasonline.nl/Account/ChangePassword');
        }
    }

    private selectAll = () => { this.toggleAllNotes(true); };
    private deselectAll = () => { this.toggleAllNotes(false); };
    private selectAllQuestions = () => { this.toggleAllQuestions(true); };
    private deselectAllQuestions = () => { this.toggleAllQuestions(false); };

    private selectAllBookmarks = () => { this.toggleAllBookmarks(true); };
    private deselectAllBookmarks = () => { this.toggleAllBookmarks(false); };
    private selectAllCategories = () => { this.toggleAllCategories(true); };
    private deselectAllCategories = () => { this.toggleAllCategories(false); };

    private getNotes = () => this.props.notes as (INote | INoteShared)[];
    private getQuestions = () => this.props.questions as (IQuestion)[];
    private getParticipants = () => this.props.participants as IParticipant[];    
    private getCategories = () => this.props.categories as ICategory[];
    private getBookmarks = () => this.props.bookmarks as IBookmark[];
    private getMyUsergroups = (currentUserId: string) => this.props.usergroups.qWhere((x: IUsergroup)=>x.userId===currentUserId && !x.type) as IUsergroup[];  
    private getUsergroupsWithMeInIt = (currentUserId: string) => this.props.usergroups.qWhere((x: IUsergroup)=>x.userIDs.includes(currentUserId) &&  !x.type) as IUsergroup[];         
    private getFactions = () => this.props.usergroups.qWhere((x: IUsergroup)=> x.type === typeFaction) as IUsergroup[];  
    private getRole = (role: number) => this.props.usergroups.qWhere((x: IUsergroup)=> x.type === role) as IUsergroup[];
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/admin/index.tsx